<template>
  <div>
    <!--account settings-->
    <div class="settings__account--profile">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            Account
            <span>Settings</span>
          </div>
        </div>
        <div class="panel__content panel__content--grey">
          <div class="parent-container">
            <div class="table table--special-width transfer__table">
              <div class="table__section table__section--body">
                <!-- <div class="table__row" v-for="(index,key) in settings">
                  <div class="table__data table__data--bold" style="width: 85%; padding-left: 40%;">
                    <div class="table__data--bold">
                      <div class="table__data--default">{{ key || 'No Name' }}</div>
                    </div>
                  </div>
                  <div class="table__data">
                    <button class="btn btn-default" @click="toShow(key)">View more</button>
                  </div>
                </div> -->

                <div class="table__row">
                  <div class="table__data table__data--bold" v-for="(index,key) in settings">
                    <div class="table__data--bold">
                      <a class="btn btn--default btn--flex" @click="toShow(key)">
                        <span class="btn__icon">+</span>{{ key || 'No Name' }}
                      </a>
                      <!-- <div class="table__data--default" @click="toShow(key)"> </div> -->
                    </div>
                    <div ></div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <hr>
            <br>
            <div class="table table--special-width transfer__table">
              <div class="table__section table__section--body">
                <div class="table__row" v-for="(index,key) in settings[whatTo]" v-if="isActive">
                  <div class="table__data table__data--bold" style="width: 15%">
                    <div class="table__data--bold">
                      <div class="table__data--default">
                        <b>{{ index.alias || 'No Name' }}</b>
                        <br>
                        <small><i>{{index.description}}</i></small>
                      </div>
                    </div>
                  </div>

                  <div class="table__data" style="width: 30%" v-if="index.name === 'enable_twofactor'">
                    <form class @submit.prevent="editUser(index.preferenceId, index.name, 2, key)">
                      <input
                        :disabled="!(toEdit == index.name || toEdit == index.preferenceId)"
                        type="checkbox"
                        name="value"
                        placeholder
                        v-model="settingsValue[index.preferenceId]"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                      >
                      
                    </form>
                  </div>
                  <div class="table__data" style="width: 30%" v-else>
                    <form class @submit.prevent="editUser(index.preferenceId, index.name, 2, key)">
                      <input
                        v-if="toEdit == index.name || toEdit == index.preferenceId"
                        type="text"
                        name="value"
                        placeholder
                        v-model="settingsValue[index.preferenceId]"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                      >
                      <input
                        v-else
                        type="text"
                        name="value"
                        placeholder
                        v-model="settingsValue[index.preferenceId]"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                        disabled
                      >
                    </form>
                  </div>
                  <div class="table__data" style="width: 9%" v-if="whatTo != 'fees'">
                    <button
                      class="btn btn--primary"
                      @click="editUser(index.preferenceId, index.name, 2, key)"
                      v-if="toEdit == index.name || toEdit == index.preferenceId"
                    >Save</button>
                    <button
                      class="btn btn-default"
                      @click="editUser('NO_ID',index.name, index.preferenceId, key)"
                      v-else
                    >Edit</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig, updateConfig } from "../../utils/user/getUserDetails";
export default {
  data() {
    return {
      users: {},
      settings: {},
      settingsValue: {},
      user: {},
      toEdit: "",
      whatTo: "",
      isActive: false
    };
  },

  created() {
    this.configNow();
  },

  components: {},
  methods: {
    configNow() {
      getConfig()
        .then(response => {
          this.settings = response.data.data;
          Object.keys(this.settings).forEach(res => {
            for (let x in this.settings[res]) {
              this.settingsValue[
                this.settings[res][x].preferenceId
              ] = this.settings[res][x].value;
            }
          });
          console.log(this.settings);
          console.log(this.settingsValue);
        })
        .catch(error => {
          console.log(error);
        });
        
    },
    editUser(id, key, conId, index) {
      console.log()
      console.log(id, key, conId, index);
      this.toEdit = conId || key;
      console.log(this.toEdit);
      if (id == "NO_ID") {
        this.configNow();
      } else {
        this.$Progress.start();
        updateConfig(id, this.settingsValue[id], key)
          .then(response => {
            this.$Progress.finish();
            console.log(response);
            this.configNow();
            this.toEdit = "";
          })
          .catch(error => {
            this.$Progress.fail();
            this.configNow();
            console.log(error);
          });
      }
    },
    toShow(key) {
      this.whatTo = key;
      this.isActive = true;
      this.toEdit = "";
    }
  }
};
</script>

<style lang="scss" scoped>
.panel__footer__right {
  .btn--default {
    margin-right: 8px;
  }
}
.select__icon {
  top: 12px;
}
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/configSettings.vue